<template>
  <div class="page-head fixed-top p-3">
    <h1 class="page-head__heading">
      <div
        v-if="hasBack"
        class="page-head__back"
        @click="back">
        <span class="material-icons">
          arrow_back_ios
        </span>
      </div>
      <slot />
    </h1>
  </div>
</template>

<script>
export default {
  props: {
    hasBack: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      default: null
    }
  },
  methods: {
    back() {
      if (!this.to) {
        this.$router.back()
        return
      }
      this.$router.push(this.to)
    }
  }
}
</script>

<style lang="scss" scoped>
.page-head {
  background-color: $l-blue;
  @media screen and (min-width:992px) {
    right: 0;
    left: 120px;
  }
  &__back{
    height: 22px;
    width: auto;
    color: $white;
    display: inline-block;
    vertical-align: text-bottom;
  }
  &__heading {
    color: $white;
    font-size: $fs-lg;
    font-weight: bold;
  }
}
</style>